import React from 'react';
import { List } from 'src/app-components/List';



import { LoadingSpinner } from '@fsg/gui-bits';
import { useRequestOnMount } from '@fsg/next-auth';



import { EntityQuery } from '@app/api/EntityQuery';
import { APIResponse, LeadResponse, OpportunityResponse } from '@app/types';





type TypedEntity<T> = T & {
  entityType: string
}

type Props = {
  leadsQuery: EntityQuery
  oppsQuery: EntityQuery
  renderListItem: (item: TypedEntity<LeadResponse | OpportunityResponse>) => JSX.Element
  sort?: (a: TypedEntity<LeadResponse | OpportunityResponse>, b: TypedEntity<LeadResponse | OpportunityResponse>) => number
  emptyMessage: string
  emptyIcon: React.ReactNode
} & Pick<React.ComponentProps<typeof List>, 'header' | 'moreActions'>

// TODO: Add sort prop and sort list data by key, and asc/desc
export function SalesActivityList(props: Props) {
  const { leadsQuery, oppsQuery, renderListItem, emptyIcon, emptyMessage, header, moreActions, sort } = props
  const { data: leadsData, status: leadsStatus, error: leadsError } = useRequestOnMount<APIResponse<LeadResponse>>({ path: leadsQuery.getPath() })
  const { data: oppsData, status: oppsStatus, error: oppsError } = useRequestOnMount<APIResponse<OpportunityResponse>>({ path: oppsQuery.getPath() })

  const isIdle = leadsStatus === 'idle' && oppsStatus === 'idle'
  const isReady = leadsStatus === 'success' && oppsStatus === 'success'
  const isLoading = leadsStatus === 'loading' && oppsStatus === 'loading'
  const didError = leadsStatus === 'error' || oppsStatus === 'error'

  const leads = leadsData?.data.map((item) => {
    return {
      ...item,
      entityType: 'lead',
    } as TypedEntity<LeadResponse>
  })

  const opps = oppsData?.data.map((item) => {
    return {
      ...item,
      entityType: 'opportunity',
    } as TypedEntity<OpportunityResponse>
  })

  const listItems = leadsData && oppsData ? [...leads, ...opps] : []

  const sortedListItems = sort
    ? listItems.sort(sort)
    : listItems.sort((a, b) => {
        if ('nextFollowUp' in a && 'nextFollowUp' in b) {
          return new Date(a.nextFollowUp).getTime() - new Date(b.nextFollowUp).getTime()
        } else {
          return 0
        }
      })

  const overlay = (
    <div className="grid place-items-center text-sm">
      {isLoading ? (
        <LoadingSpinner />
      ) : didError ? (
        <p className="text-error">Error fetching data</p>
      ) : isReady && listItems.length === 0 ? (
        <EmptyOverlay message={emptyMessage ?? 'Nothing Here'} icon={emptyIcon} />
      ) : null}
    </div>
  )

  const defaultMoreActions = <div className="gap-4xs flex w-full flex-col py-xs text-[14px]"></div>
  return (
    <List header={header} data={sortedListItems} moreActions={moreActions} isLoading={isLoading} renderListItem={renderListItem} overlay={overlay} />
  )
}

type EmptyProps = {
  icon?: React.ReactNode
  message?: string
}
function EmptyOverlay(props: EmptyProps) {
  const { icon, message } = props
  const styles = {
    iconWrapper: 'inline-block h-[48px] min-h-[48px] w-[48px] min-w-[48px] rounded-full bg-gray-200 p-xs relative mb-[8px]',
  }

  return (
    <>
      <div className={styles.iconWrapper}>{icon}</div> {message}
    </>
  )
}